<template>
  <new-password
    :recover-id="recoverId"
    :token="token"
    :recover-password="recoverPassword"
    :verification-token="verificationToken"
    :new-password="newPasswordCallback"
    @login="goToLogin"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { NewPassword } from '@last/core-ui/shared'

import { newPasswordCallback, recoverPassword, verificationToken } from '@/api/auth'

const route = useRoute()
const router = useRouter()

const recoverId = computed(() => route.params.recoverId as string)
const token = computed(() => route.params.token as string)

function goToLogin() {
  router.push({ name: 'login' })
}
</script>
